import { render, staticRenderFns } from "./content-in-iframe.vue?vue&type=template&id=67c740a6"
import script from "./content-in-iframe.vue?vue&type=script&lang=js"
export * from "./content-in-iframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports